<template>
    <div class="relative rounded-lg bg-white text-eureka-500 hover:bg-white/80">
        <ElTooltip
            effect="light"
            :show-arrow="false"
            :offset="16"
            placement="right"
            popper-class="pt-ui-tooltip"
            :content="menu.tip"
        >
            <div
                class="flex flex-row justify-center items-center gap-2 px-2 py-2 cursor-pointer"
                @click="clickMenu"
            >
                <div class="flex flex-row relative">
                    <PtIcon v-if="menu.icon" class="fill-current shrink-0 text-2xl" :icon="menu.icon" />
                </div>
                <template v-if="opened">
                    <span class="flex-1">{{ menu.title }}</span>
                    <PtIcon class="fill-current shrink-0 text-xl" icon="SolidArrowRight" />
                </template>
            </div>
        </ElTooltip>
    </div>
</template>

<script lang="ts" setup>
import { ElTooltip } from 'element-plus';
import { PtIcon } from 'patsnap-biz';
import type { NavMenuItem, NAV_MENU_TYPE } from '../types';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';
import '@patsnap-ui/icon/assets/solid/secutiry.svg';

const props = defineProps<{
    menu: NavMenuItem & { tip: string }
    opened: boolean;
}>();

const emits = defineEmits<{
    (event: 'handleClick', type: NAV_MENU_TYPE): Promise<void>;
}>();

function clickMenu() {
    emits('handleClick', props.menu.type);
}
</script>
